import { Pencil, X, Save } from 'lucide-react';
import { showDialogConfermaModifica, showDialogConfermaAnnulla, showDialogConfermaSalva } from '../../../utils/dialog/showDialogFunction';

interface EditActionBarProps {
  isEditing: boolean;
  onProcedi: () => void;
  onAnnulla: () => void;
  onSalva:   () => void;
  /** Se true, il bottone "Modifica" appare disabilitato (es. report gia' approvato). */
  disabled?: boolean;
}

export const EditActionBar = ({ isEditing, onProcedi, onAnnulla, onSalva, disabled = false }: EditActionBarProps) => (
  <div className="flex items-center gap-2">
    {!isEditing ? (
      <button
        onClick={() => { if (!disabled) showDialogConfermaModifica(onProcedi); }}
        disabled={disabled}
        title={disabled ? 'Report validato: riapri il report per modificare i driver' : undefined}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-600 hover:border-[#1B365D]/40 hover:text-[#1B365D] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-gray-200 disabled:hover:text-gray-600"
      >
        <Pencil className="w-3 h-3" />
        Modifica
      </button>
    ) : (
      <>
        <button
          onClick={() => showDialogConfermaAnnulla(onAnnulla)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-medium text-gray-500 hover:border-red-300 hover:text-red-500 transition-all"
        >
          <X className="w-3 h-3" />
          Annulla
        </button>
        <button
          onClick={() => showDialogConfermaSalva(onSalva)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#1B365D] text-xs font-medium text-white hover:bg-[#1B365D]/90 transition-all"
        >
          <Save className="w-3 h-3" />
          Salva
        </button>
      </>
    )}
  </div>
);
